<template>
    <v-main v-if="org">
        <v-row class="ma-0">
            <v-col class="ma-0 py-0">
                <ContactC />
            </v-col>
        </v-row>
        <v-container>
            <v-dialog v-model="dialog" persistent max-width="500">
                <v-card>
                    <router-view ></router-view>
                </v-card>
            </v-dialog>
        </v-container>
    </v-main>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import ContactC from "@/components/contacts/ContactC";
  export default {
    components: {ContactC},
    name: "Contacts",
    data() {
      return {

      }
    },
    watch:{
      $route(){
        this.$forceUpdate();
      }
    },
    computed:{
      ...mapState(['org', 'icons','activecontact']),
      dialog(){
        return this.$route.path!=="/contacts"
      }
    },
    mounted(){

    }
  }
</script>

<style scoped>

</style>